<script setup lang="ts">
const showPopup = defineModel('showPopup');
const formChoose = defineModel('formChoose');
const closePopup = () => {
  showPopup.value = false;
};
const forgetPassword = () => {
  formChoose.value = 'ForgetPassword';
  showPopup.value = false;
};
</script>
<template>
  <div class="card">
    <p>帳號或密碼錯誤</p>
    <ul>
      <li>1.請確認帳號或密碼是否正確</li>
      <li>2.請確認當初是否由第三方註冊</li>
      <li>
        3.若確認資料正確，可以點<span @click="forgetPassword">忘記密碼</span>查詢註冊時候的帳號密碼
      </li>
    </ul>
    <button @click="closePopup">確定</button>
  </div>
</template>
<style scoped lang="scss">
.card {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 290px;
  background-color: #ffffff;
  box-shadow: 0px 1px 16px #00000029;
  border-radius: 8px;
  padding: 24px;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}
p {
  width: 100%;
  color: #191919cc;
  font-weight: 600;
  font-size: 18px;
}
ul {
  color: #19191966;
  font-size: 14px;
  padding: 0 4px;
  margin: 4px 0 16px;
  line-height: 19.6px;
  li {
    span {
      color: #f74768;
      cursor: pointer;
      &:hover {
        text-decoration: underline;
        text-decoration-color: #f74768;
      }
    }
  }
}
button {
  width: 100%;
  height: 40px;
  background-color: #f74768;
  border-radius: 4px;
  border: none;
  color: white;
  font-size: 16px;
  cursor: pointer;
}

.junior-landing-page > .main-content > .popup-overlay > .card {
  > button {
    background-color: $color-brownish-100;
  }

  ul {
    li {
      span {
        color: $color-brownish-100;
        &:hover {
          text-decoration-color: $color-brownish-100;
        }
      }
    }
  }
}
</style>
